<template>
    <div id="app">
        <!-- <div v-if="isWX" class="wx-tips">
            <p>复制以下网址在浏览器打开：</p>
            <p>{{ wxUrl }}</p>
        </div>
        <router-view v-else></router-view> -->
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: "index",
  computed: {
    isWX () {
      var ua = navigator.userAgent.toLowerCase() //获取判断用的对象
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //在微信中打开
        return true
      }
      return false
    },
    wxUrl() {
        let url = window.location.href
        url = url.replace(/[?&]nsukey=([^?&]*)($|&)/, '')
        return url
    }
  }
};
</script>

<style>
@import "../static/css/main.css";
@import "../static/css/color-dark.css"; /* 深色主题*/
/*@import "../static/css/theme-green/color-green.css";   浅绿色主题*/
.wx-tips {
  background: url("../static/img/share.png");
  background-size: contain;
  background-repeat: none;
  background-position: center center;
  height: 100%;
  width: 100%;
  padding-top: 60px;
  box-sizing: border-box;
  text-align: center;
  font-family: "Helvetica Neue", Helvetica, "microsoft yahei", arial, STHeiTi,
    sans-serif;
}
.wx-tips p {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 2em;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// App.vue?6ae8e67c